import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';
import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { selectResetPassword } from '@/features/user/resetPassword/selectResetPassword';

const ResetPasswordPage = lazy(() =>
  import('@/components/pages/ResetPasswordPage').then(({ ResetPasswordPage }) => ({ default: ResetPasswordPage })),
);

export const ResetPasswordRoute: AppRouteConfig = {
  key: 'forgot-password-page',
  path: '/reset_password/:token/:locale?',
  component: ResetPasswordPage,
  screenRef: ScreenRef.RESET_PASSWORD,
  actionRef: ActionRef.RESET_PASSWORD,
  selector: selectResetPassword,
};
